import { useMemo } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Formik } from "formik";
import validationSchema from "./index.schema";
import AppInputField from "components/shared/FormComponents/AppInputField";
import LoadingButton from "components/shared/LoadingButton";
import { successMessageToast } from "helpers/common";
import close from "../../../Assets/images/cross_icon.png"
// css
import styles from "./index.module.scss";
import CKEditorField from "components/CkEditor/CkEditor";
import { RequiredFieldAstrick } from "components/Common/Common";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import { useCreateStrategyTemplateMutation } from "store/services/clients/reports-v2/recommendationTemplates";
import { useGetDisciplineTagsQuery } from "store/services/utility";
import { useSelector } from "react-redux";

const SaveStrategyTemplatePop = ({ showPopup, closePopup, data, clientType, currentStrategyFieldName = 'strategy', assessmentId, outerFieldName, strategyIndex, index, mainSetFieldValue }) => {
  const [createTemplate] = useCreateStrategyTemplateMutation();
  const [updateTemplate] = useCreateStrategyTemplateMutation();

  const disciplineId = useSelector((state) => state?.auth?.user?.therapist_discipline?.id)
  const { data: disciplineTags, isFetching: areasLoading } = useGetDisciplineTagsQuery(disciplineId, { skip: !disciplineId });
  const disciplineTagOptions = disciplineTags?.length > 0 ? disciplineTags?.map(area => ({ value: area.id, label: area.name })) : [];

  const editMode = !!data?.id;

  const initialValues = useMemo(() => {
    return {
      title: data?.title || "",
      answers: data?.answers || "",
      // assesment_type: assessmentId,
    }
  }, [data, assessmentId]);

  const addToReport = (values) => {
    mainSetFieldValue(`${outerFieldName}.${index}.${currentStrategyFieldName}.${strategyIndex}.answers`, values?.answers)
    mainSetFieldValue(`${outerFieldName}.${index}.${currentStrategyFieldName}.${strategyIndex}.title`, values?.title)
  }

  const handleSubmit = async (values) => {
    try {
      if (data?.id) {
        await updateTemplate({ id, clientType, values }).unwrap();
      }
      await createTemplate({ clientType, values }).unwrap();
      addToReport(values)
      successMessageToast("Template saved successfully");
      closePopup();
    } catch (err) {
      console.error("Error saving strategy template", err);
    }
  }

  return (
    <Modal
      show={showPopup}
      className={`${styles.AddNewGoalPop} modal-v2 AddNewGoalPop`}
      onHide={closePopup}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            handleSubmit,
            setFieldValue,
            isSubmitting,
            errors,
            values,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="reports-v2">
                <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                  <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{editMode ? "Edit TEMPLATES" : "SAVE A TEMPLATES"}</h6>
                  <img onClick={closePopup} width={16} height={16} src={close} alt="close" style={{ cursor: "pointer" }} />
                </div>
                <Row >
                  <Col md="9" className="my-2 name-input-v2">
                    <label
                      htmlFor=""
                      className="discharge-screen-label mt-0"
                    >
                      Name
                      <RequiredFieldAstrick />
                    </label>
                    <AppInputField
                      name="title"
                      className={`${styles.formControl} readonly-box h-auto`}
                      styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                      placeholder="Enter strategy name"
                    />
                  </Col>
                  <Col md="12" className="mt-2">
                    <label
                      htmlFor=""
                      className="discharge-screen-label mt-0"
                    >
                      Description
                      <RequiredFieldAstrick />
                    </label>
                    <div className="editor-paren-v2">
                      <CustomEditor style={{ borderRadius: 0 }} name={`answers`} />
                    </div>
                    {/* <CKEditorField
                        items={[
                          'bold',
                          'italic',
                          'underline',
                          'alignment',
                          '|',
                          'bulletedList',
                          'numberedList',
                        ]}
                        value={values?.answers}
                        handleChange={(event, editor) => {
                          setFieldValue(`answers`, editor?.getData());
                        }}
                      /> */}
                  </Col>
                  <Col md="12" className="mb-2">
                    <label className="discharge-screen-label mt-0 mb-0">
                      Tag
                      <RequiredFieldAstrick />
                    </label>

                    <div className="d-flex area-pills flex-wrap gap-2 mt-2">
                      {disciplineTagOptions.map((tag) => (
                        <button
                          key={tag}
                          type="button"
                          // variant={values.tags?.includes(tag?.value) ? "primary" : "outline-secondary"}
                          className={values.tags?.includes(tag?.value) ? "select-liberary-btn proxima-regular" : "non-select-liberary-btn proxima-regular"}
                          onClick={() => {
                            if (values.tags?.includes(tag?.value)) {
                              setFieldValue(
                                "tags",
                                values.tags.filter((t) => t !== tag?.value)
                              );
                            } else {
                              setFieldValue("tags", [...(values.tags || []), tag?.value]);
                            }
                          }}
                        >
                          {tag?.label}
                        </button>
                      ))}
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="btnWrpper mt-2 text-end d-flex justify-content-end">
                <LoadingButton
                  type="submit"
                  className="blue-discharge-screen-btn"
                  isLoading={isSubmitting}
                >
                  Save to Templates
                </LoadingButton>

                {/* <LoadingButton
                  type="button"
                  className="blue-discharge-screen-btn"
                  onClick={() => { addToReport(values); closePopup(); }}
                  isLoading={isSubmitting}
                >
                  Add to Report
                </LoadingButton> */}
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default SaveStrategyTemplatePop;
